import React from 'react';
import classNames from 'classnames';
import { consumptionBarWidth } from '../logic';

type Props = {
  consumedPercent: number | null;
  overBudget: boolean;
};

// A consumed-vs-available bar. The fill width is clamped to [0, 100] (see
// consumptionBarWidth) while the caller shows the true percent as a label;
// over-budget turns the fill red.
export const ConsumptionBar: React.FC<Props> = ({
  consumedPercent,
  overBudget,
}) => (
  <div
    className="budget-consumption-bar"
    role="progressbar"
    aria-valuemin={0}
    aria-valuemax={100}
    aria-valuenow={consumedPercent ?? undefined}>
    <div
      className={classNames('budget-consumption-bar__fill', {
        'budget-consumption-bar__fill--over': overBudget,
      })}
      style={{ width: `${consumptionBarWidth(consumedPercent, overBudget)}%` }}
    />
  </div>
);
